import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';

import css from './SectionBookingSteps.module.css';

const STEPS = ['step1', 'step2', 'step3'];

/**
 * "So bucht ihr auf Toastably" three-step explainer, ported from the
 * kategorie pages. Chrome-free drop-in section — no outer margins.
 *
 * @param {Object} props
 * @param {string?} props.className
 * @param {string?} props.rootClassName
 */
const SectionBookingSteps = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <section className={classes}>
      <div className={css.container}>
        <div className={css.sectionHead}>
          <h2 className={css.title}>
            <FormattedMessage id="SectionBookingSteps.title" />
          </h2>
          <p className={css.subtitle}>
            <FormattedMessage id="SectionBookingSteps.subtitle" />
          </p>
        </div>
        {/* role="list" restores the list semantics that `list-style: none`
            strips in Safari/VoiceOver. */}
        <ol className={css.steps} role="list">
          {STEPS.map((step, i) => (
            <li key={step}>
              <div className={css.stepNum} aria-hidden="true">
                {i + 1}
              </div>
              <h3 className={css.stepTitle}>
                <FormattedMessage id={`SectionBookingSteps.${step}Title`} />
              </h3>
              <p className={css.stepText}>
                <FormattedMessage id={`SectionBookingSteps.${step}Text`} />
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default SectionBookingSteps;
